const formatStringDate = (stringDate: string): string => {
  if (!stringDate.length) {
    return "";
  }

  const date = new Date(stringDate);

  return formatDate(date);
};

const formatDate = (date: Date) =>
  new Date(date).toLocaleDateString("es", {
    hour12: false,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const addDayDate = (date: Date) => {  const newDate = new Date(date);  return new Date(newDate.setDate(newDate.getDate() + 1));}; 

const formatDateString = (date: Date): string => {
  return date.toISOString().split("T")[0];
};

const addMinutes = (date: Date, minutes: number) =>
  new Date(date.getTime() + minutes * 60000);

export {
  formatStringDate,
  formatDateString,
  formatDate,
  addMinutes,
  addDayDate,
};
